export function isMobile() {
  return (
    (typeof navigator !== 'undefined'
      && /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent || navigator.vendor,
      ))
    || (typeof window !== 'undefined'
      && ('ontouchstart' in window
        || navigator.maxTouchPoints > 0
        || window.innerWidth < 768))
  )
}

function getBrowserName(userAgent: string) {
  if (!userAgent) {
    userAgent = navigator.userAgent
  }

  if (/Opera|OPR\//.test(userAgent)) {
    return 'Opera'
  } if (/Edg\//.test(userAgent)) {
    return 'Microsoft Edge'
  } if (/Chrome\//.test(userAgent) && !/Chromium/.test(userAgent)) {
    return 'Chrome'
  } if (/Safari\//.test(userAgent) && !/Chrome\//.test(userAgent)) {
    return 'Safari'
  } if (/Firefox\//.test(userAgent)) {
    return 'Firefox'
  } if (/MSIE|Trident/.test(userAgent)) {
    return 'Internet Explorer'
  }
  return 'Unknown Browser'
}

export function checkDappMobile(window: any) {
  let isDapp = false
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  let browser = getBrowserName(userAgent)

  if (window.phantom?.solana?.isPhantom && isMobile()) {
    browser = 'PhantomWallet'
    isDapp = true
  }

  if (window.solflare?.isSolflare && isMobile()) {
    browser = 'SolflareWallet'
    isDapp = true
  }

  return { isDapp, browser, meta: userAgent }
}
